import { AlertAttributionPage } from '@/pages/AlertAttribution';

export function HTTPExceptionQueryPage() {
  return <AlertAttributionPage mode="http-exception-query" />;
}
